import { Component, DestroyRef, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';

import { Header } from './components/header/header';
import { MessageDialog } from './components/message-dialog/message-dialog';
import { OrderStore } from './order-store';
import { ApiService } from './services/api.service';
import { MessageDialogService } from './services/message-dialog.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, MessageDialog],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly route = inject(ActivatedRoute);
  private readonly apiService = inject(ApiService);
  private readonly store = inject(OrderStore);
  private readonly messageDialogService = inject(MessageDialogService);
  private readonly destroyRef = inject(DestroyRef);

  readonly isChatBoxOpen = signal(false);

  constructor() {
    // queryParams is used instead of the snapshot because the Router's initial
    // navigation resolves asynchronously after this root component is constructed.
    const subscription = this.route.queryParams.subscribe((params) => {
      const hasParams = Object.keys(params).length > 0;
      if (hasParams !== window.location.href.includes('?')) {
        return;
      }
      if (hasParams) {
        this.store.setUrlParams({
          oid: params['o'],
          routeType: params['r'],
          key: params['key'],
          lt: params['lt'],
        });
        this.apiService.getOrderInfo();
        this.apiService.getTimeslots();
      } else {
        this.messageDialogService.showMessage({ type: 'error' });
      }
    });
    this.destroyRef.onDestroy(() => subscription.unsubscribe());
  }

  public chatBoxEvent(isOpen: boolean): void {
    this.isChatBoxOpen.set(isOpen);
  }
}
